export default "__VITE_ASSET__jj2IXG2x__"